import {createAction, createAsyncThunk} from '@reduxjs/toolkit';

import {MAPBOX_ACCESS_TOKEN} from '../config';

export const reset = createAction('GEOCODER_RESET');

const API_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

export const geocode = createAsyncThunk(
  'GEOCODE',
  (query, {dispatch, rejectWithValue}) => {
    if (!query) {
      return dispatch(reset());
    }

    const encoded = encodeURIComponent(query);
    const types = 'country,region,place,locality,neighborhood';
    return fetch(
      `${API_URL}/${encoded}.json?types=${types}&access_token=${MAPBOX_ACCESS_TOKEN}`
    )
      .then(res => res.json())
      .then(res => {
        if (res.type !== 'FeatureCollection' || res.message === 'Not Found') {
          throw new Error('There was an error while searching');
        } else {
          return res.features;
        }
      })
      .catch(err => {
        return rejectWithValue(err.message || err);
      });
  }
);
